module.exports = __webpack_public_path__ + "static/media/background-dark.a5e91384.png";